export { default as InputRightAddon } from './InputRightAddon'
